import { Injectable, Type } from '@angular/core';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import type { ICvSubscriptionScheduleData } from 'src/shared/models/subscriptions.model';
import { SubscriptionSchedulerService } from 'src/app/reusables/subscription-scheduler/subscription-scheduler.service';

@Injectable({
  providedIn: 'root'
})
export class SendToSubscriptionService {

  private modalData: SendToSubscriptionOptions = null;

  constructor(
      private modalService: NgbModal,
      private schedulerService: SubscriptionSchedulerService,
  ) { }

  public openModal(options: SendToSubscriptionOptions, modalComponent: Type<any>): NgbModalRef {
      if (!options || typeof options !== "object")
          throw "Options argument is required";
      if (typeof options.moduleKey !== "string" || options.moduleKey.length == 0)
          throw "Module key is required";

      this.modalData = options;

      const modalRef = this.modalService.open(modalComponent, {
        animation: true,
        backdrop: 'static',
        backdropClass: 'stopScrolling',
        size: 'lg'
      });

      return modalRef;
  }

  public _getModalData(): SendToSubscriptionOptions {
      let modalData = this.modalData;
      this.modalData = null;
      return modalData;
  }

  public _sendSubscription(existingModuleKey: string, schedule: ICvSubscriptionScheduleData) {
      return this.schedulerService.createSubscriptionScheduleFromExistingModule(existingModuleKey, schedule);
  }
}

export type SendToSubscriptionCallbackSave = (obj: { subscriptionID: number; moduleKey: string }) => void;
export type SendToSubscriptionCallbackDismiss = () => void;
export interface SendToSubscriptionOptions {
    callbackSave?: SendToSubscriptionCallbackSave,
    callbackDismiss?: SendToSubscriptionCallbackDismiss,
    moduleKey: string,
    moduleName: string,
    timezone?: string,
}
